import ResultHandler from "../ResultHandler";
import "./CustomTable.css";
import i18next, { t } from "i18next";

export default function CustomTable({ cols, data, emptyMsg, loading, error }) {
  const getColStyle = (col) => {
    return col.style?.textAlign === "right"
      ? { ...col.style, textAlign: i18next.language === "ar" ? "left" : "right" }
      : col.style;
  };

  return (
    <div>
      <div className="custom-table-row d-flex align-items-center">
        {cols.map((col) => (
          <span key={`header-${col.key}`} style={{ fontWeight: "bold", ...getColStyle(col) }}>
            {t(col.label)}
          </span>
        ))}
      </div>

      <ResultHandler loading={loading} error={error} />

      {data && data.length === 0 && (
        <p className="font-size-17 text-center mb-0 empty-table">{t(emptyMsg)}</p>
      )}

      {data &&
        data.map((row) => (
          <div key={row.id} className="custom-table-row d-flex align-items-center">
            {cols.map((col) => (
              <span key={`cell-${row.id}-${col.key}`} style={getColStyle(col)}>
                {(col.renderer ? col.renderer(row) : row[col.key]) || "-"}
              </span>
            ))}
          </div>
        ))}
    </div>
  );
}
